import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './views/Home';
import Programs from './views/Programs';
import Competitive from './views/Competitive';
import Recreation from './views/Recreation';
import Resources from './views/Resources';
import Coaching from './views/Coaching';
import Schedules from './views/Schedules';
import About from './views/About';
import Refereeing from './views/Refereeing'
import Tryout from './views/Tryout';
import Policies from './views/Policies';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/policies" element={<Policies/>} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/competitive" element={<Competitive />} />
        <Route path="/recreation" element={<Recreation />} />
        <Route path="/schedules" element={<Schedules />} />
        <Route path="/about" element={<About />} />
        <Route path="/refereeing" element={<Refereeing />} />
        <Route path="/tryout" element={<Tryout />} />
      </Routes>
       
    </div>
  );
}

export default App;
